
export default function TitleArea({ title, subTitle, forMobile }) {

  return (
    <div className={`title-area ${forMobile?'only-mobile':'only-desktop'}`}>
        <h2>{title}</h2>
        <div dangerouslySetInnerHTML={{ __html: subTitle }} />
    </div>
  );
}
